import ClipboardJS from "clipboard";

export async function writeToClipboard(value: string) {
  return ClipboardJS.copy(value);
}
